import { render, staticRenderFns } from "./FusionMobileCatalogPreference.vue?vue&type=template&id=63ff227a&scoped=true"
import script from "./FusionMobileCatalogPreference.vue?vue&type=script&lang=js"
export * from "./FusionMobileCatalogPreference.vue?vue&type=script&lang=js"
import style0 from "./FusionMobileCatalogPreference.vue?vue&type=style&index=0&id=63ff227a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff227a",
  null
  
)

export default component.exports